<template>
  <v-container class="register-page py-8">
    <v-row align="stretch">
      <v-col cols="12" md="7" class="register-page__form">
        <div class="register-panel register-panel--form">
          <RegisterView
            :new-route="afterRegisterRoute"
            :source-register-id="sourceRegisterId"
          />
        </div>
      </v-col>
      <v-col cols="12" md="5" class="register-page__aside">
        <div class="register-panel register-panel--aside">
          <section class="register-togo">
            <h3 class="text-green register-togo-kicker">Für Zahnärzte kostenlos</h3>
            <h2 class="register-togo-title">
              Jetzt WaizmannTabellen
              <span class="text-green">{{ baseStore.thisYear }}</span>
              anfordern
            </h2>
            <p class="register-togo-lead">
              Nach der Registrierung gelangen Sie wie gewohnt zur Seite
              <strong>WaizmannTabellen bestellen</strong> — dort wählen Sie Ihre Tabellen und Aufsteller aus.
            </p>
            <ul class="register-togo-list">
              <li>
                <span class="register-togo-list__label">WaizmannTabellen</span>
                passend zur Praxis auswählen (z.&nbsp;B. PZR-Flatrate, Zahnzusatz &amp; mehr).
              </li>
              <li>
                <span class="register-togo-list__label">Aufsteller</span>
                optional dazu: Premium (Acrylglas) oder Standard fürs Wartezimmer — beides
                <span class="text-green">kostenlos</span> anforderbar.
              </li>
              <li>
                <span class="register-togo-list__label">Gesamtausgabe</span>
                alle Tarife im Überblick — ideal für den Lesebereich.
              </li>
            </ul>
            <p class="register-togo-foot text-medium-emphasis">
              Über {{ dataplugin.getData('zahnarzt') }} Zahnärzte nutzen bereits die WaizmannTabelle.
            </p>
          </section>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed, inject, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import RegisterView from '@/components/objects/user/RegisterView.vue'
import { useBaseStore } from '@/stores/baseStore'

const route = useRoute()
const updateDocumentHead = inject('updateDocumentHead')
const dataplugin = inject('dataplugin')
const baseStore = useBaseStore()

const sourceRegisterId = computed(() => {
  const id = route.params.id
  if (id === undefined || id === null || id === '') {
    return ''
  }
  return String(id)
})

const afterRegisterRoute = '/waizmanntabellen_bestellen'

onMounted(() => {
  updateDocumentHead(
    'TeamWaizmann | Kostenlos registrieren',
    'Kostenlos bei TeamWaizmann registrieren und WaizmannTabellen anfordern.'
  )
})
</script>

<style scoped>
.register-panel {
  background: #ffffff;
  border: 1px solid #e1e6ef;
  border-radius: 10px;
  padding: 22px;
  box-shadow: 0 8px 24px rgba(16, 42, 67, 0.06);
  height: 100%;
}

.register-panel--form {
  border-top: 4px solid #2e7d32;
}

.register-panel--aside {
  border-top: 4px solid #2e7d32;
}

/* An BestellenIndex / .togo-section angelehnt */
.register-togo {
  background-color: #f7f9fc;
  border-radius: 8px;
  padding: 20px 18px 16px;
}

.register-togo-kicker {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 8px;
  letter-spacing: 0.01em;
}

.register-togo-title {
  color: #1f3a63;
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1.2;
  margin: 0 0 14px;
}

.register-togo-lead {
  margin: 0 0 16px;
  color: #4a5568;
  line-height: 1.45;
  font-size: 0.95rem;
}

.register-togo-lead strong {
  color: #3166a5;
}

.register-togo-list {
  margin: 0;
  padding-left: 1.15rem;
  color: #4a5568;
  line-height: 1.5;
  font-size: 0.92rem;
}

.register-togo-list li {
  margin-bottom: 11px;
}

.register-togo-list__label {
  display: block;
  color: #3166a5;
  font-weight: 600;
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 2px;
}

.register-togo-foot {
  margin: 16px 0 0;
  padding-top: 12px;
  border-top: 1px solid #e1e6ef;
  font-size: 0.88rem;
  line-height: 1.45;
}
</style>
